
import {html} from "lit"
import {debounce} from "@e280/stz"
import {shadow, useCss, useDerived, useName, useOnce, useSignal} from "@e280/sly"

import stylesCss from "./styles.css.js"
import themeCss from "../../theme.css.js"

import {constants} from "../../../constants.js"
import {TimeView} from "../../views/time/view.js"
import {Timelink} from "../../../logic/timelink.js"
import { stupidDatetimeFormat } from "../../../tools/stupid-datetime-format.js"

export const AuthorView = shadow(() => {
	useName("author")
	useCss(themeCss, stylesCss)

	const $time = useSignal(Date.now())
	const $text = useSignal("")
	const $timelink = useDerived(() => new Timelink($time(), $text()))

	const timelinkUrl = $timelink().toUrl()
	const remaining = constants.textLimit - $text().length

	const updateMarkdown = useOnce(() => {
		const update = debounce(200, (input: HTMLTextAreaElement) => {
			$text((input.value ?? "").trim())
		})
		return (event: Event) => update(event.currentTarget as HTMLTextAreaElement)
	})

	const updateTime = (event: InputEvent) => {
		const input = event.currentTarget as HTMLInputElement
		$time(new Date(input.value).getTime())
	}

	return html`
		<section theme-plate>
			<input
				class="timepicker input"
				type=datetime-local
				@input="${updateTime}"
				value="${stupidDatetimeFormat(Date.now())}"
				/>
			<textarea
				class="text input"
				theme-markdown
				placeholder="short optional markdown description..."
				maxlength="${constants.textLimit}"
				@input="${updateMarkdown}"
			></textarea>
			<small>${remaining} character${remaining === 1 ?"" :"s"} remaining</small>
		</section>

		<section theme-plate>
			${TimeView($timelink)}
		</section>

		<a
			theme-plate
			class=timelink
			rel="nofollow"
			target=_blank
			href="${timelinkUrl}">
			${timelinkUrl}
		</a>
	`
})

